// extracted by mini-css-extract-plugin
module.exports = {"color-input-info":"style_color-input-info__1Vnf0"};